import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';

import { IUserDetails } from "../user-datails";
import { UpdateDetailsService } from "./update-details.service";

@Component({
    moduleId: module.id,
    templateUrl: './update.details.component.html',
    providers: [UpdateDetailsService]
})

export class UpdateDetailsComponent implements OnInit {
    rishum: FormGroup;
    user: IUserDetails;
    errorMessage: string;
    is_submited: boolean = false;
    isvalidform: boolean = true;

    constructor(private _updateDetailsService: UpdateDetailsService, private router: Router, private fb: FormBuilder) { }

    ngOnInit(): void {

        this.rishum = this.fb.group({
            phone: ['', [Validators.required, Validators.pattern('^[0][5][0-9]{8}$')]],
            email: ['', [CustomValidators.email]]
        });

        this._updateDetailsService.getUserDetails()
            .subscribe(u => {
            this.user = u
                this.rishum.patchValue(u);
            },
            error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                } else if (error.includes("400")) {
                    this.router.navigateByUrl('/keep-in-touch/rishum-expired');
                }
                else {
                    this.isvalidform = false;
                    this.errorMessage = error;
                }
            })       
    }
    
    onSubmit(event, { value, valid }: { value: IUserDetails, valid: boolean }) {
        event.preventDefault();
        this.is_submited = true;
        if (valid) {
            this._updateDetailsService.saveUserDetails(value)
                .subscribe(r => {
                    if (r.status) {
                        this.router.navigate(['/keep-in-touch/endrishum']);
                    }

                    this.isvalidform = false;
                    this.is_submited = false;
                    this.errorMessage = r.returnMessage;
                },
                error => {
                    if (error.includes("401")) {
                        localStorage.removeItem("token");
                        location.reload();
                    }
                    this.isvalidform = false;
                    this.errorMessage = error;
                    this.is_submited = false;
                });
        }
    }
}